export default "__VITE_ASSET__CAi81wct__"